/* BuzzIslands global HTML entity decoder.
   Use this before rendering product text that may arrive from Shopify translations
   as numeric entities such as &#924;&#945; instead of normal Greek letters. */
(function () {
  'use strict';

  var ENTITY_RE = /&(?:#\d+|#x[\da-f]+|[a-z][\w]+);/i;

  function decodeHtmlEntities(value) {
    if (value == null || typeof value !== 'string') return value;
    if (value.indexOf('&') === -1 || !ENTITY_RE.test(value)) return value;

    try {
      var textarea = document.createElement('textarea');
      textarea.innerHTML = value;
      var decoded = textarea.value;
      if (textarea.remove) textarea.remove();
      return decoded;
    } catch (err) {
      return value;
    }
  }

  window.BuzzDecodeHtmlEntities = window.BuzzDecodeHtmlEntities || decodeHtmlEntities;
  window.BuzzDecodeProductHtml = window.BuzzDecodeProductHtml || decodeHtmlEntities;
})();
